
(function () {
  'use strict';
  if (window.__bbMattressShowroomV2) return;
  window.__bbMattressShowroomV2 = true;

   function rootsIn(root) {
    var out = [];
    if (root && root.matches && root.matches('[data-bb-mattress-showroom]')) out.push(root);
    if (root && root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-bb-mattress-showroom]'), function (el) {
        if (out.indexOf(el) === -1) out.push(el);
      });
    }
    return out.filter(function (el) { return !el.hasAttribute('data-bb-mattress-showroom-bound'); });
  }

  function one(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function setText(root, selector, text) {
    var el = one(root, selector);
    if (el) el.textContent = text || '';
  }

  function setLink(link, href) {
    if (!link) return;
    if (href) {
      link.setAttribute('href', href);
      link.hidden = false;
    } else {
      link.removeAttribute('href');
      link.hidden = true;
    }
  }

  function normalStore(raw) {
    var BB = window.BB;
    if (BB && BB.stores && typeof BB.stores.normalize === 'function') return BB.stores.normalize(raw);
    return raw || null;
  }

  function evidenceGroups(rawStores, strictExact) {
    var BB = window.BB;
    var selection = BB.showroom.selectStores(rawStores, strictExact);
    return { exact: selection.exact, brand: selection.brand };
  }

  function hydrateCard(root, rawStore) {
    var BB = window.BB;
    var store = normalStore(rawStore);
    if (!store || !store.slug) return false;

    var item = one(root, '[data-bb-mattress-store][data-store-slug="' + CSS.escape(store.slug) + '"]');
    if (!item) return false;

    var card = one(item, '.bb-store-card');
    if (!card) return false;

    var title = one(card, '[data-store-name]');
    var addressEl = one(card, '[data-store-address]');
    var statusEl = one(card, '[data-store-status]');
    var hoursEl = one(card, '[data-store-hours-fallback]');
    var pageLink = one(card, '[data-store-page-link]');
    var routeLink = one(card, '[data-bb-store-route]');
    var phoneLink = one(card, '[data-bb-store-call]');
    var emailLink = one(card, '[data-store-email]');
    var appointment = one(card, '[data-bb-appointment]');

    if (title && store.name) title.textContent = store.name;

    if (BB.stores && BB.stores.format) {
      var address = BB.stores.format.address(store.address);
      if (addressEl) {
        addressEl.textContent = address.singleLine || '';
        addressEl.hidden = !address.singleLine;
      }

      if (statusEl) {
        statusEl.textContent = '';
        statusEl.classList.remove('is-open', 'is-closed');
        statusEl.hidden = true;
      }

      var openState = BB.stores.format.openState(store);
      if (openState.state === 'open' || openState.state === 'closed') {
        if (statusEl) {
          statusEl.textContent = openState.text;
          statusEl.classList.add('is-' + openState.state);
          statusEl.hidden = false;
        }
        if (hoursEl) hoursEl.hidden = true;
      } else if (hoursEl) {
        hoursEl.textContent = openState.text;
        hoursEl.hidden = false;
      }

      setLink(pageLink, store.shopifyPageUrl);
      setLink(routeLink, BB.stores.format.routeUrl(store));

      var phoneHref = BB.stores.format.telHref(store);
      setLink(phoneLink, phoneHref);
      var phoneText = one(phoneLink, '[data-store-phone-text]');
      if (phoneText) phoneText.textContent = phoneHref && store.contact && store.contact.phone ? store.contact.phone : '';

      var emailHref = BB.stores.format.emailHref(store);
      setLink(emailLink, emailHref);
      var emailText = one(emailLink, '[data-store-email-text]');
      if (emailText) emailText.textContent = emailHref && store.contact && store.contact.email ? store.contact.email : '';
    }

    if (appointment) {
      var productGid = root.getAttribute('data-product-gid') || '';
      var productTitle = root.getAttribute('data-product-title') || '';
      var brand = root.getAttribute('data-brand') || '';

      if (store.slug) appointment.setAttribute('data-store-slug', store.slug);
      if (store.name) appointment.setAttribute('data-store-name', store.name);
      if (productGid) appointment.setAttribute('data-product-gid', productGid);
      if (productTitle) appointment.setAttribute('data-product-title', productTitle);
      if (brand) {
        appointment.setAttribute('data-vendor', brand);
        appointment.setAttribute('data-brand', brand);
      }
    }

    item.hidden = false;
    return true;
  }

  function showCards(root, stores) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-bb-mattress-store]'), function (item) {
      item.hidden = true;
    });

    var visible = 0;
    (stores || []).forEach(function (store) {
      if (hydrateCard(root, store)) visible += 1;
    });
    return visible;
  }

  function showMap(root, stores) {
    var wrap = one(root, '[data-bb-mattress-map-wrap]');
    var map = one(root, '[data-bb-mattress-map]');
    if (!wrap || !map || typeof map.setStores !== 'function') return;

    var points = [];
    (stores || []).forEach(function (rawStore) {
      var store = normalStore(rawStore);
      if (!store || !store.slug || !store.coordinates) return;
      var lat = Number(store.coordinates.latitude);
      var lng = Number(store.coordinates.longitude);
      if (!isFinite(lat) || !isFinite(lng)) return;
      points.push({ slug: store.slug, name: store.name || '', lat: lat, lng: lng });
    });

    map.setStores(points);
    wrap.hidden = points.length === 0;
    if (points.length && typeof map.show === 'function') map.show();

    var workspace = one(root, '[data-bb-mattress-showroom-workspace]');
    if (workspace) workspace.classList.toggle('has-map', points.length > 0);
  }

  function setSingleStoreContext(root, stores) {
    var cta = one(root, '[data-bb-mattress-showroom-cta]');
    if (!cta) return;

    cta.removeAttribute('data-store-slug');
    cta.removeAttribute('data-store-name');

    if (stores.length === 1) {
      var store = normalStore(stores[0]);
      if (!store) return;
      if (store.slug) cta.setAttribute('data-store-slug', store.slug);
      if (store.name) cta.setAttribute('data-store-name', store.name);
    }
  }

  function replaceToken(value, token, replacement) {
    return (value || '').split(token).join(replacement || '');
  }

  function applyResult(root, rawStores) {
    var unique = root.hasAttribute('data-bb-unique-showroom');
    var groups = evidenceGroups(rawStores, unique);
    var mode = groups.exact.length ? 'exact' : (!unique && groups.brand.length ? 'brand' : 'none');
    var selected = unique && groups.exact.length !== 1 ? [] : (mode === 'exact' ? groups.exact : (mode === 'brand' ? groups.brand : []));

    var visible = showCards(root, selected);
    var heading = one(root, '[data-bb-mattress-showroom-heading]');
    var status = one(root, '[data-bb-mattress-showroom-status]');
    var first = selected.length ? normalStore(selected[0]) : null;
    var singleName = selected.length === 1 && first && first.name ? first.name : '';

    if (heading) {
      if (mode === 'exact' && selected.length === 1) {
        heading.textContent = replaceToken(root.getAttribute('data-heading-singular'), '[store]', singleName);
      } else if (mode === 'exact') {
        heading.textContent = root.getAttribute('data-heading-plural') || root.getAttribute('data-heading-default');
      } else if (mode === 'brand' && selected.length === 1) {
        heading.textContent = replaceToken(root.getAttribute('data-heading-brand-singular'), '[store]', singleName);
      } else if (mode === 'brand') {
        heading.textContent = root.getAttribute('data-heading-brand-plural') || root.getAttribute('data-heading-default');
      } else {
        heading.textContent = root.getAttribute('data-heading-default');
      }
    }

    if (status) {
      if (mode === 'exact' && selected.length === 1) {
        status.textContent = replaceToken(root.getAttribute('data-status-singular'), '[store]', singleName);
      } else if (mode === 'exact') {
        status.textContent = replaceToken(root.getAttribute('data-status-plural'), '[count]', String(selected.length));
      } else if (mode === 'brand' && selected.length === 1) {
        status.textContent = replaceToken(root.getAttribute('data-status-brand-singular'), '[store]', singleName);
      } else if (mode === 'brand') {
        status.textContent = replaceToken(root.getAttribute('data-status-brand-plural'), '[count]', String(selected.length));
      } else {
        status.textContent = root.getAttribute('data-status-neutral');
      }
    }

    var grid = one(root, '[data-bb-mattress-showroom-grid]');
    if (grid) {
      grid.hidden = visible === 0;
      grid.setAttribute('data-store-count', String(visible));
    }

    showMap(root, selected);
    setSingleStoreContext(root, mode === 'exact' ? selected : []);

    root.setAttribute('data-evidence-state', 'loaded');
    root.setAttribute('data-match-mode', mode);
    root.setAttribute('data-exact-store-count', String(groups.exact.length));
    root.setAttribute('data-brand-store-count', String(groups.brand.length));
  }

  function initOne(root) {
    root.setAttribute('data-bb-mattress-showroom-bound', '');
    root.setAttribute('data-evidence-state', 'loading');

    var BB = window.BB;
    if (!BB || !BB.showroom || typeof BB.showroom.fetchStores !== 'function') {
      setText(root, '[data-bb-mattress-showroom-status]', root.getAttribute('data-status-neutral'));
      root.setAttribute('data-evidence-state', 'unavailable');
      return;
    }

    var ctx = BB.showroom.context({
      productGid: root.getAttribute('data-product-gid') || '',
      brand: root.getAttribute('data-brand') || ''
    });

    if (!ctx || !ctx.productGid) {
      setText(root, '[data-bb-mattress-showroom-status]', root.getAttribute('data-status-neutral'));
      root.setAttribute('data-evidence-state', 'none');
      return;
    }

    BB.showroom.fetchStores(ctx).then(function (stores) {
      applyResult(root, stores);
    }).catch(function () {
      setText(root, '[data-bb-mattress-showroom-status]', root.getAttribute('data-status-neutral'));
      root.setAttribute('data-evidence-state', 'error');
    });
  }

  function init(root) {
    rootsIn(root || document).forEach(initOne);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
